import { composeIO } from 'react-compose-io'
import { tabAssociacaoIO } from './TabAssociacao.IO'
import TabAssociacaoView from './TabAssociacao.View'

export const TabAssociacao = composeIO(TabAssociacaoView, tabAssociacaoIO)
